import React from 'react';
import { Trophy, X } from 'lucide-react';

const MILESTONES = [10, 25, 50, 100, 250, 500, 1000];

const MILESTONE_MESSAGES = {
  10:   { title: 'I er i gang!',           desc: '10 kærlighedspoint sammen.' },
  25:   { title: 'Sjældent godt holdspil', desc: '25 point — I er rigtig godt på vej.' },
  50:   { title: 'Halvvejs til 100!',      desc: '50 point. Behold momentet.' },
  100:  { title: 'Tre cifre!',             desc: '100 kærlighedspoint. Det er en milepæl værd at fejre.' },
  250:  { title: 'I er et powerpar',       desc: '250 point. Få jer en ekstra lang krammer.' },
  500:  { title: 'Stærkt arbejde',         desc: '500 point sammen. Det her er kunst.' },
  1000: { title: 'Tag Team-mestre',        desc: '1000 point. I har vundet hjemmet.' },
};

export function getMilestone(prevScore, newScore) {
  for (const m of MILESTONES) {
    if (prevScore < m && newScore >= m) return m;
  }
  return null;
}

export function MilestoneAlert({ theme, milestone, onClose }) {
  // Special case: custom milestone (e.g. partner accepted invite)
  if (milestone?.custom) {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 350,
        padding: 20,
      }} onClick={onClose}>
        <style>{`
          @keyframes tt-milestone-in {
            0% { transform: scale(0.7); opacity: 0; }
            60% { transform: scale(1.05); }
            100% { transform: scale(1); opacity: 1; }
          }
          .tt-milestone-card { animation: tt-milestone-in 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }
        `}</style>
        <div className="tt-milestone-card" onClick={e => e.stopPropagation()} style={{
          background: theme.bgElevated,
          border: `2px solid ${theme.coral}`,
          borderRadius: 20,
          padding: '32px 28px',
          textAlign: 'center',
          maxWidth: 360,
          width: '100%',
          position: 'relative',
          boxShadow: `0 20px 80px ${theme.coral}40`,
        }}>
          <button onClick={onClose} style={{
            position: 'absolute', top: 12, right: 12,
            background: 'transparent', border: 'none',
            color: theme.textMuted, cursor: 'pointer',
            padding: 4,
          }}><X size={18} /></button>

          <div style={{ fontSize: 56, marginBottom: 6 }}>💕</div>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: theme.text }}>
            I er nu et Tag Team!
          </h2>
          <p style={{ margin: '8px 0 20px', fontSize: 14, color: theme.textMuted, lineHeight: 1.5 }}>
            {milestone.partnerName ? `${milestone.partnerName} accepterede din invitation.` : 'Din invitation er accepteret.'} Lad jagten på kærlighedspoint begynde.
          </p>

          <button onClick={onClose} style={{
            background: theme.coral,
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: 10,
            fontSize: 14,
            fontWeight: 700,
            cursor: 'pointer',
          }}>Lad os komme i gang</button>
        </div>
      </div>
    );
  }

  const data = MILESTONE_MESSAGES[milestone];
  if (!data) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 350,
      padding: 20,
    }} onClick={onClose}>
      <style>{`
        @keyframes tt-milestone-in {
          0% { transform: scale(0.7); opacity: 0; }
          60% { transform: scale(1.05); }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes tt-trophy-bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        .tt-milestone-card { animation: tt-milestone-in 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }
        .tt-trophy { animation: tt-trophy-bounce 1.6s ease-in-out infinite; }
      `}</style>

      <div className="tt-milestone-card" onClick={e => e.stopPropagation()} style={{
        background: theme.bgElevated,
        border: `2px solid ${theme.gold}`,
        borderRadius: 20,
        padding: '32px 28px',
        textAlign: 'center',
        maxWidth: 360,
        width: '100%',
        position: 'relative',
        boxShadow: `0 20px 80px ${theme.gold}40`,
      }}>
        {/* Close */}
        <button onClick={onClose} style={{
          position: 'absolute', top: 12, right: 12,
          background: 'transparent', border: 'none',
          color: theme.textMuted, cursor: 'pointer',
          padding: 4,
        }}><X size={18} /></button>

        <div className="tt-trophy" style={{ marginBottom: 12 }}>
          <Trophy size={48} color={theme.gold} fill={theme.gold} fillOpacity={0.3} />
        </div>

        <div style={{
          fontSize: 48,
          fontWeight: 900,
          color: theme.gold,
          lineHeight: 1,
          marginBottom: 4,
        }}>{milestone}</div>
        <div style={{
          fontSize: 11,
          color: theme.textMuted,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 2,
          marginBottom: 16,
        }}>Kærlighedspoint</div>

        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: theme.text }}>{data.title}</h2>
        <p style={{ margin: '8px 0 20px', fontSize: 14, color: theme.textMuted, lineHeight: 1.5 }}>{data.desc}</p>

        <button onClick={onClose} style={{
          background: theme.gold,
          color: '#1a1612',
          border: 'none',
          padding: '12px 24px',
          borderRadius: 10,
          fontSize: 14,
          fontWeight: 700,
          cursor: 'pointer',
        }}>Fortsæt</button>
      </div>
    </div>
  );
}
